import script from "./BaseChannelsTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseChannelsTable.vue?vue&type=script&setup=true&lang=ts"

import "./BaseChannelsTable.vue?vue&type=style&index=0&id=3507df39&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3507df39"]])

export default __exports__